import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Icons
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

// Imgs
import zoomErrorPic from '../../util/imgs/zoom_error.webp';

const FAQ_Container = () => {

    const [dropdown_1, setDropdown_1] = useState(true);
    const [dropdown_2, setDropdown_2] = useState(false);
    const [dropdown_3, setDropdown_3] = useState(false);
    const [dropdown_4, setDropdown_4] = useState(false);
    const [dropdown_5, setDropdown_5] = useState(false);

    return (
        <div style={{width: '100%', boxSizing: 'border-box', padding: '8px 8px 0', flexWrap: 'wrap', display: 'flex', margin: 'auto', border: '1px solid rgba(64,64,64,.4)', borderRadius: '1rem'}}>
            <div style={{padding: '24px 0', display: 'flex', flexDirection: 'column', flex: 1}}>
                <div onClick={() => setDropdown_1(!dropdown_1)} style={{width: '100%', overflow: 'hidden', borderBottom: '1px solid rgba(64,64,64,.4)'}}>
                    <div className='faq_dropdown_header'>
                        <div style={{marginRight: '12px', flex: 1}}>
                            <div style={{maxWidth: '100%', textOverflow: 'ellipsis', fontSize: '18px', fontWeight: 500, overflow: 'hidden'}}>
                                Is Interview Cheater free?
                            </div>
                        </div>
                        <div style={{border: '2px solid #000', height: '25px', width: '25px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            {dropdown_1 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </div>
                    </div>
                    <div style={{height: `${dropdown_1 ? '51px' : '0'}`, overflow: 'hidden', margin: '0 16px'}}>
                        <div style={{fontSize: '14px'}}>
                            No, it's not. It's free to download, but you must subscribe to get access to the latest AI models that ensure you pass your technical interviews.
                        </div>
                    </div>
                </div>
                <div onClick={() => setDropdown_2(!dropdown_2)} style={{width: '100%', overflow: 'hidden', borderBottom: '1px solid rgba(64,64,64,.4)'}}>
                    <div className='faq_dropdown_header'>
                        <div style={{marginRight: '12px', flex: 1}}>
                            <div style={{maxWidth: '100%', textOverflow: 'ellipsis', fontSize: '18px', fontWeight: 500, overflow: 'hidden'}}>
                                How is it undetectable?
                            </div>
                        </div>
                        <div style={{border: '2px solid #000', height: '25px', width: '25px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            {dropdown_2 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </div>
                    </div>
                    <div style={{height: `${dropdown_2 ? '51px' : '0'}`, overflow: 'hidden', margin: '0 16px'}}>
                        <div style={{fontSize: '14px'}}>
                            Our software is designed to be completely undetectable to interviewers. It can not be seen or detected by Zoom, screen recorders, or any browser based screen capture system. 
                        </div>
                    </div>
                </div>
                <div onClick={() => setDropdown_3(!dropdown_3)} style={{width: '100%', overflow: 'hidden', borderBottom: '1px solid rgba(64,64,64,.4)'}}>
                    <div className='faq_dropdown_header'>
                        <div style={{marginRight: '12px', flex: 1}}>
                            <div style={{maxWidth: '100%', textOverflow: 'ellipsis', fontSize: '18px', fontWeight: 500, overflow: 'hidden'}}>
                                What programming languages are supported?
                            </div>
                        </div>
                        <div style={{border: '2px solid #000', height: '25px', width: '25px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            {dropdown_3 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </div>
                    </div>
                    <div style={{height: `${dropdown_3 ? '51px' : '0'}`, overflow: 'hidden', margin: '0 16px'}}>
                        <div style={{fontSize: '14px'}}>
                            Python, Golang, C#, Rust, R, SQL, Ruby, Java, Javascript, C++, Kotlin, and Swift. You can edit your preferred language in the app or in your settings.
                        </div>
                    </div>
                </div>
                <div onClick={() => setDropdown_4(!dropdown_4)} style={{width: '100%', overflow: 'hidden', borderBottom: '1px solid rgba(64,64,64,.4)'}}>
                    <div className='faq_dropdown_header'>
                        <div style={{marginRight: '12px', flex: 1}}>
                            <div style={{maxWidth: '100%', textOverflow: 'ellipsis', fontSize: '18px', fontWeight: 500, overflow: 'hidden'}}>
                                I'm experiencing a bug, what should I do
                            </div>
                        </div>
                        <div style={{border: '2px solid #000', height: '25px', width: '25px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            {dropdown_4 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </div>
                    </div>
                    <div style={{height: `${dropdown_4 ? '51px' : '0'}`, overflow: 'hidden', margin: '0 16px'}}>
                        <div style={{fontSize: '14px'}}>
                            9 times out of 10, you can uninstall and reinstall the app from this website. If that doesn't work, please email us and we'll get back to you within 24 hours.
                        </div>
                    </div>
                </div>
                <div onClick={() => setDropdown_5(!dropdown_5)} style={{width: '100%', overflow: 'hidden'}}>
                    <div className='faq_dropdown_header'>
                        <div style={{marginRight: '12px', flex: 1}}>
                            <div style={{maxWidth: '100%', textOverflow: 'ellipsis', fontSize: '18px', fontWeight: 500, overflow: 'hidden'}}>
                                Does the app work with current Zoom versions?
                            </div>
                        </div>
                        <div style={{border: '2px solid #000', height: '25px', width: '25px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            {dropdown_5 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </div>
                    </div>
                    <div style={{height: `${dropdown_5 ? 'auto' : '0'}`, overflow: 'hidden', margin: '0 16px'}}>
                        <div style={{fontSize: '14px'}}>
                        Yes, absolutely! All you have to do is enable 
                        {' '}
                        <a href="https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0063824#:~:text=Advanced%20capture%20with%20window%20filtering,from%20the%20Zoom%20desktop%20app." target='_blank' className='underline_hover' style={{color: '#FFFF00', textDecoration: 'none'}}>
                            Advanced capture with window filtering
                        </a>
                        .
                        </div>
                        <div style={{width: '100%', marginTop: '1rem'}}>
                            <img alt="Zoom Advanced Capture Settings" loading="lazy" decoding="async" src={zoomErrorPic} style={{width: '100%', height: 'auto'}} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

FAQ_Container.propTypes = {}

export default FAQ_Container